(() => {
  "use strict";
  class SaWidgetSlider {
    constructor(e) {
      if (
        ((this.config = SaWidgetSlider.mergeSettings(e)),
        (this.selector =
          "string" == typeof this.config.selector
            ? document.querySelector(this.config.selector)
            : this.config.selector),
        null === this.selector)
      )
        throw new Error("Something wrong with your selector ðŸ˜­");
      this.resolveSlidesNumber(),
        (this.selectorWidth = this.selector.offsetWidth),
        (this.innerElements = [].slice.call(this.selector.children)),
        this.config.loop &&
          this.innerElements.length <= this.perPage &&
          (this.config.loop = !1),
        (this.currentSlide = this.config.loop
          ? this.config.startIndex % this.innerElements.length
          : Math.max(
              0,
              Math.min(
                this.config.startIndex,
                this.innerElements.length - this.perPage
              )
            )),
        (this.transformProperty = SaWidgetSlider.webkitOrNot()),
        [
          "resizeHandler",
          "touchstartHandler",
          "touchendHandler",
          "touchmoveHandler",
          "mousedownHandler",
          "mouseupHandler",
          "mouseleaveHandler",
          "mousemoveHandler",
          "clickHandler",
        ].forEach((e) => {
          this[e] = this[e].bind(this);
        }),
        this.init();
    }
    static mergeSettings(e) {
      const t = {
          selector: ".siema",
          duration: 200,
          easing: "ease-out",
          perPage: 1,
          startIndex: 0,
          draggable: !0,
          multipleDrag: !0,
          threshold: 20,
          loop: !1,
          rtl: !1,
          onInit: () => {},
          onChange: () => {},
          onResize: () => {},
          onDragEnd: () => {},
          onDragStart: () => {},
        },
        i = e;
      for (const e in i) t[e] = i[e];
      return t;
    }
    static webkitOrNot() {
      return "string" == typeof document.documentElement.style.transform
        ? "transform"
        : "WebkitTransform";
    }
    attachEvents() {
      window.addEventListener("resize", this.resizeHandler),
        this.config.draggable &&
          ((this.pointerDown = !1),
          (this.drag = {
            startX: 0,
            endX: 0,
            startY: 0,
            letItGo: null,
            preventClick: !1,
          }),
          this.selector.addEventListener("touchstart", this.touchstartHandler),
          this.selector.addEventListener("touchend", this.touchendHandler),
          this.selector.addEventListener("touchmove", this.touchmoveHandler),
          this.selector.addEventListener("mousedown", this.mousedownHandler),
          this.selector.addEventListener("mouseup", this.mouseupHandler),
          this.selector.addEventListener("mouseleave", this.mouseleaveHandler),
          this.selector.addEventListener("mousemove", this.mousemoveHandler),
          this.selector.addEventListener("click", this.clickHandler));
    }
    detachEvents() {
      window.removeEventListener("resize", this.resizeHandler),
        this.selector.removeEventListener("touchstart", this.touchstartHandler),
        this.selector.removeEventListener("touchend", this.touchendHandler),
        this.selector.removeEventListener("touchmove", this.touchmoveHandler),
        this.selector.removeEventListener("mousedown", this.mousedownHandler),
        this.selector.removeEventListener("mouseup", this.mouseupHandler),
        this.selector.removeEventListener("mouseleave", this.mouseleaveHandler),
        this.selector.removeEventListener("mousemove", this.mousemoveHandler),
        this.selector.removeEventListener("click", this.clickHandler);
    }
    init() {
      this.attachEvents(),
        (this.selector.style.overflow = "hidden"),
        (this.selector.style.direction = this.config.rtl ? "rtl" : "ltr"),
        this.buildSliderFrame(),
        this.config.onInit.call(this);
    }
    buildSliderFrame() {
      const e = this.selectorWidth / this.perPage,
        t = this.config.loop
          ? this.innerElements.length + 2 * this.perPage
          : this.innerElements.length;
      (this.sliderFrame = document.createElement("div")),
        (this.sliderFrame.style.width = e * t + "px"),
        this.enableTransition(),
        this.config.draggable && (this.selector.style.cursor = "-webkit-grab");
      const i = document.createDocumentFragment();
      if (this.config.loop)
        for (
          let e = this.innerElements.length - this.perPage;
          e < this.innerElements.length;
          e++
        ) {
          const t = this.buildSliderFrameItem(
            this.innerElements[e].cloneNode(!0)
          );
          i.appendChild(t);
        }
      for (let e = 0; e < this.innerElements.length; e++) {
        const t = this.buildSliderFrameItem(this.innerElements[e]);
        i.appendChild(t);
      }
      if (this.config.loop)
        for (let e = 0; e < this.perPage; e++) {
          const t = this.buildSliderFrameItem(
            this.innerElements[e].cloneNode(!0)
          );
          i.appendChild(t);
        }
      this.sliderFrame.appendChild(i),
        (this.selector.innerHTML = ""),
        this.selector.appendChild(this.sliderFrame),
        this.slideToCurrent();
    }
    buildSliderFrameItem(e) {
      const t = document.createElement("div");
      return (
        (t.style.cssFloat = this.config.rtl ? "right" : "left"),
        (t.style.float = this.config.rtl ? "right" : "left"),
        (t.style.width =
          (this.config.loop
            ? 100 / (this.innerElements.length + 2 * this.perPage)
            : 100 / this.innerElements.length) + "%"),
        t.appendChild(e),
        t
      );
    }
    resolveSlidesNumber() {
      if ("number" == typeof this.config.perPage)
        this.perPage = this.config.perPage;
      else if ("object" == typeof this.config.perPage) {
        this.perPage = 1;
        for (const e in this.config.perPage)
          window.innerWidth >= e && (this.perPage = this.config.perPage[e]);
      }
    }
    prev(e = 1, t) {
      if (this.innerElements.length <= this.perPage) return;
      const i = this.currentSlide;
      if (this.config.loop) {
        if (this.currentSlide - e < 0) {
          this.disableTransition();
          const t = this.currentSlide + this.innerElements.length,
            i = t + this.perPage,
            s =
              (this.config.rtl ? 1 : -1) *
              i *
              (this.selectorWidth / this.perPage),
            r = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
          (this.sliderFrame.style[this.transformProperty] = `translate3d(${
            s + r
          }px, 0, 0)`),
            (this.currentSlide = t - e);
        } else this.currentSlide = this.currentSlide - e;
      } else this.currentSlide = Math.max(this.currentSlide - e, 0);
      i !== this.currentSlide &&
        (this.slideToCurrent(this.config.loop),
        this.config.onChange.call(this),
        t && t.call(this));
    }
    next(e = 1, t) {
      if (this.innerElements.length <= this.perPage) return;
      const i = this.currentSlide;
      if (this.config.loop) {
        if (this.currentSlide + e > this.innerElements.length - this.perPage) {
          this.disableTransition();
          const t = this.currentSlide - this.innerElements.length,
            i = t + this.perPage,
            s =
              (this.config.rtl ? 1 : -1) *
              i *
              (this.selectorWidth / this.perPage),
            r = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
          (this.sliderFrame.style[this.transformProperty] = `translate3d(${
            s + r
          }px, 0, 0)`),
            (this.currentSlide = t + e);
        } else this.currentSlide = this.currentSlide + e;
      } else
        this.currentSlide = Math.min(
          this.currentSlide + e,
          this.innerElements.length - this.perPage
        );
      i !== this.currentSlide &&
        (this.slideToCurrent(this.config.loop),
        this.config.onChange.call(this),
        t && t.call(this));
    }
    disableTransition() {
      (this.sliderFrame.style.webkitTransition = `all 0ms ${this.config.easing}`),
        (this.sliderFrame.style.transition = `all 0ms ${this.config.easing}`);
    }
    enableTransition() {
      (this.sliderFrame.style.webkitTransition = `all ${this.config.duration}ms ${this.config.easing}`),
        (this.sliderFrame.style.transition = `all ${this.config.duration}ms ${this.config.easing}`);
    }
    goTo(e, t) {
      if (this.innerElements.length <= this.perPage) return;
      const i = this.currentSlide;
      (this.currentSlide = this.config.loop
        ? e % this.innerElements.length
        : Math.min(Math.max(e, 0), this.innerElements.length - this.perPage)),
        i !== this.currentSlide &&
          (this.slideToCurrent(),
          this.config.onChange.call(this),
          t && t.call(this));
    }
    slideToCurrent(e) {
      const t = this.config.loop
          ? this.currentSlide + this.perPage
          : this.currentSlide,
        i =
          (this.config.rtl ? 1 : -1) * t * (this.selectorWidth / this.perPage);
      e
        ? requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.enableTransition(),
                (this.sliderFrame.style[
                  this.transformProperty
                ] = `translate3d(${i}px, 0, 0)`);
            });
          })
        : (this.sliderFrame.style[
            this.transformProperty
          ] = `translate3d(${i}px, 0, 0)`);
    }
    updateAfterDrag() {
      const e =
          (this.config.rtl ? -1 : 1) * (this.drag.endX - this.drag.startX),
        t = Math.abs(e),
        i = this.config.multipleDrag
          ? Math.ceil(t / (this.selectorWidth / this.perPage))
          : 1,
        s = e > 0 && this.currentSlide - i < 0,
        r =
          e < 0 &&
          this.currentSlide + i > this.innerElements.length - this.perPage;
      e > 0 &&
      t > this.config.threshold &&
      this.innerElements.length > this.perPage
        ? this.prev(i)
        : e < 0 &&
          t > this.config.threshold &&
          this.innerElements.length > this.perPage &&
          this.next(i),
        this.slideToCurrent(s || r);
    }
    resizeHandler() {
      this.resolveSlidesNumber(),
        this.currentSlide + this.perPage > this.innerElements.length &&
          (this.currentSlide =
            this.innerElements.length <= this.perPage
              ? 0
              : this.innerElements.length - this.perPage),
        (this.selectorWidth = this.selector.offsetWidth),
        this.buildSliderFrame(),
        this.config.onResize.call(this);
    }
    clearDrag() {
      this.config.onDragEnd.call(this),
        (this.drag = {
          startX: 0,
          endX: 0,
          startY: 0,
          letItGo: null,
          preventClick: this.drag.preventClick,
        });
    }
    touchstartHandler(e) {
      -1 !==
        ["TEXTAREA", "OPTION", "INPUT", "SELECT"].indexOf(e.target.nodeName) ||
        (e.stopPropagation(),
        (this.pointerDown = !0),
        (this.drag.startX = e.touches[0].pageX),
        (this.drag.startY = e.touches[0].pageY));
    }
    touchendHandler(e) {
      this.config.onDragStart.call(this),
        e.stopPropagation(),
        (this.pointerDown = !1),
        this.enableTransition(),
        this.drag.endX && this.updateAfterDrag(),
        this.clearDrag();
    }
    touchmoveHandler(e) {
      if (
        (e.stopPropagation(),
        null === this.drag.letItGo &&
          (this.drag.letItGo =
            Math.abs(this.drag.startY - e.touches[0].pageY) <
            Math.abs(this.drag.startX - e.touches[0].pageX)),
        this.pointerDown && this.drag.letItGo)
      ) {
        e.preventDefault(),
          (this.drag.endX = e.touches[0].pageX),
          (this.sliderFrame.style.webkitTransition = `all 0ms ${this.config.easing}`),
          (this.sliderFrame.style.transition = `all 0ms ${this.config.easing}`);
        const t =
            (this.config.loop
              ? this.currentSlide + this.perPage
              : this.currentSlide) *
            (this.selectorWidth / this.perPage),
          i = this.drag.endX - this.drag.startX,
          s = this.config.rtl ? t + i : t - i;
        this.sliderFrame.style[this.transformProperty] = `translate3d(${
          (this.config.rtl ? 1 : -1) * s
        }px, 0, 0)`;
      }
    }
    mousedownHandler(e) {
      -1 !==
        ["TEXTAREA", "OPTION", "INPUT", "SELECT"].indexOf(e.target.nodeName) ||
        (e.preventDefault(),
        e.stopPropagation(),
        (this.pointerDown = !0),
        (this.drag.startX = e.pageX));
    }
    mouseupHandler(e) {
      e.stopPropagation(),
        (this.pointerDown = !1),
        (this.selector.style.cursor = "-webkit-grab"),
        this.enableTransition(),
        this.drag.endX && this.updateAfterDrag(),
        this.clearDrag();
    }
    mousemoveHandler(e) {
      if ((e.preventDefault(), this.pointerDown)) {
        "A" === e.target.nodeName && (this.drag.preventClick = !0),
          (this.drag.endX = e.pageX),
          (this.selector.style.cursor = "-webkit-grabbing"),
          (this.sliderFrame.style.webkitTransition = `all 0ms ${this.config.easing}`),
          (this.sliderFrame.style.transition = `all 0ms ${this.config.easing}`);
        const t =
            (this.config.loop
              ? this.currentSlide + this.perPage
              : this.currentSlide) *
            (this.selectorWidth / this.perPage),
          i = this.drag.endX - this.drag.startX,
          s = this.config.rtl ? t + i : t - i;
        this.sliderFrame.style[this.transformProperty] = `translate3d(${
          (this.config.rtl ? 1 : -1) * s
        }px, 0, 0)`;
      }
    }
    mouseleaveHandler(e) {
      this.pointerDown &&
        ((this.pointerDown = !1),
        (this.selector.style.cursor = "-webkit-grab"),
        (this.drag.endX = e.pageX),
        (this.drag.preventClick = !1),
        this.enableTransition(),
        this.updateAfterDrag(),
        this.clearDrag());
    }
    clickHandler(e) {
      this.drag.preventClick && e.preventDefault(),
        (this.drag.preventClick = !1);
    }
    remove(e, t) {
      if (e < 0 || e >= this.innerElements.length)
        throw new Error("Item to remove doesn't exist ðŸ˜­");
      const i = e < this.currentSlide,
        s = this.currentSlide + this.perPage - 1 === e;
      (i || s) && this.currentSlide--,
        this.innerElements.splice(e, 1),
        this.buildSliderFrame(),
        t && t.call(this);
    }
    insert(e, t, i) {
      if (t < 0 || t > this.innerElements.length + 1)
        throw new Error("Unable to inset it at this index ðŸ˜­");
      if (-1 !== this.innerElements.indexOf(e))
        throw new Error("The same item in a carousel? Really? Nope ðŸ˜­");
      const s = t <= this.currentSlide > 0 && this.innerElements.length;
      (this.currentSlide = s ? this.currentSlide + 1 : this.currentSlide),
        this.innerElements.splice(t, 0, e),
        this.buildSliderFrame(),
        i && i.call(this);
    }
    prepend(e, t) {
      this.insert(e, 0), t && t.call(this);
    }
    append(e, t) {
      this.insert(e, this.innerElements.length + 1), t && t.call(this);
    }
    destroy(e = !1, t) {
      if ((this.detachEvents(), (this.selector.style.cursor = "auto"), e)) {
        const e = document.createDocumentFragment();
        for (let t = 0; t < this.innerElements.length; t++)
          e.appendChild(this.innerElements[t]);
        (this.selector.innerHTML = ""),
          this.selector.appendChild(e),
          this.selector.removeAttribute("style");
      }
      t && t.call(this);
    }
  }
  class WidgetHandler {
    constructor(e) {
      (this.widgets = e),
        (this.eventRegisterd = !1),
        (this.transitions = []),
        (this.timeouts = []);
    }
    iterateWidgets = (e) => {
      this.widgets.forEach((t, i) => {
        e(i, t);
      });
    };
    render = async () => {
      this.createWidgets();
    };
    createWidget = (e, t = null) => {
      e.attachShadow({ mode: "open" });
      let i = document.createElement("div");
      const s = e.dataset.widgetId ?? null,
        r = e.dataset.retailerId ?? null,
        n = e.dataset.widgetTheme ?? "light";
      s &&
        r &&
        fetch("https://widget.shopauskunft.de/" + r + "/" + s + ".html")
          .then((e) => {
            if (200 !== e.status) throw new Error("Could not fetch widget");
            return e.text();
          })
          .then((r) => {
            if (!r) return !0;
            let l = "sa_widget_" + s;
            null !== t && (l += "_" + t),
              (i.id = l),
              i.classList.add(n, s),
              (i.innerHTML = r);
            let o = document.createElement("style"),
              a = "";
            (a +=
              "@import url('https://widget.shopauskunft.de/assets/widget.css');"),
              (o.innerHTML =
                "@import url('https://widget.shopauskunft.de/assets/widget.css');"),
              i.prepend(o),
              e.shadowRoot.append(i);
            const d = e.shadowRoot.querySelector(
              "#" + l + " .sa_slider_widget_reviews_slider"
            );
            if (!d) {
              const t = e.shadowRoot.querySelector(
                "#" + l + " .sa-trust-widget"
              );
              if (t) {
                const i = e.shadowRoot.querySelector("#" + l);
                this.initTrustWidget(t, i, e.dataset.widgetId);
              }
              return !0;
            }
            this.initSliderItem(e, d);
          });
    };
    sa_widget_fade = (e, t = !1, i, s) => {
      let r = "sa_fade_in";
      t
        ? ((e.style.display = e.classList.contains("sa-trust-widget-extended")
            ? "grid"
            : "flex"),
          setTimeout(() => e.classList.add(r), 0))
        : (e.classList.remove(r),
          setTimeout(() => (e.style.display = "none"), 1e3));
    };
    initTrustWidget = (e, t, i) => {
      const s = this;
      let r = document.querySelector("body"),
        n = document.querySelector(
          '.shopauskunft-widget[data-widget-id="' + i + '"]'
        ),
        l = t.querySelector(".sa-trust-widget-extended"),
        o = t.querySelector(".sa-trust-widget");
      (n.style.position = "fixed"),
        (n.style.bottom = "0px"),
        (n.style.left = "0px"),
        (n.style.width = "100%"),
        (n.style.zIndex = "10");
      const a = () => {
          if (window.innerWidth <= 767) {
            const e = o.dataset.mobile ?? "below";
            "hide" === e
              ? (n.style.display = "none")
              : ((n.style.display = "block"),
                (o.style.display = "grid"),
                (n.style.position = "relative"),
                "above" === e ? r.prepend(n) : r.append(n));
          } else
            r.append(n),
              (n.style.display = "flex"),
              (o.style.display = "flex"),
              (n.style.position = "fixed");
        },
        d = t.querySelector(".sa-widget-trust-widget");
      if ((d && (d.style.display = "block"), !r || !n)) return;
      a(),
        (this.transitions[i] = !1),
        document.addEventListener("scroll", () => {
          if (!0 === s.transitions[i] || !e || !o) return;
          let e = t.querySelector(".sa-trust-widget-extended");
          e && s.sa_widget_fade(e, !1, t),
            setTimeout(() => (s.transitions[i] = !1), 1e3);
        }),
        window.addEventListener("resize", (e) => {
          a();
        }),
        document.addEventListener("click", (e) => {
          if (!0 === s.transitions[i] || !l || !o) return;
          let r = !1,
            n = !1;
          e.target.classList.contains("shopauskunft-widget") &&
            (e.target.shadowRoot &&
              e.target.shadowRoot.querySelector(
                ".sa-trust-widget:not(.sa-flying-widget)"
              ) &&
              (r = !0),
            e.target.shadowRoot.querySelector(
              ".sa-trust-widget:not(.sa-flying-widget)"
            ) && (n = !0)),
            (s.transitions[i] = !0),
            r || (s.sa_widget_fade(l, !1, t, i), s.sa_widget_fade(o, !0, t, i)),
            n &&
              "grid" !== l.style.display &&
              (s.sa_widget_fade(o, !1, t, i), s.sa_widget_fade(l, !0, t, i)),
            setTimeout(() => (s.transitions[i] = !1), 1e3);
        });
      let h = t.querySelector(".sa-widget-close-btn");
      h &&
        (h.onclick = () => {
          s.sa_widget_fade(l, !1, t, i), s.sa_widget_fade(o, !0, t, i);
        });
    };
    initSliderItem = (e, t) => {
      const i = this;
      e.style.margin = "0 52px";
      const s = this.getItemsPerSlide(t),
        r = new SaWidgetSlider({
          selector: t,
          duration: 400,
          easing: "ease-out",
          perPage: s,
          startIndex: 0,
          draggable: !0,
          multipleDrag: !0,
          loop: !0,
          threshold: 20,
          rtl: !1,
          onInit: function () {
            i.handleSlider(this, t, e);
          },
          onResize: function () {
            i.hideSliderPreview(), i.handleSlider(r, t, e);
          },
          onDragEnd: () => i.hideSliderPreview(),
          onChange: function () {
            let e = Math.ceil(this.currentSlide / this.perPage);
            e < 0 && (e = 0),
              t
                .closest(".sa-slider-widget_reviews")
                .querySelectorAll(".sa_slider_widget_reviews_dot")
                .forEach((t, i) => {
                  Number(t.dataset.index) === e
                    ? t.classList.add("active")
                    : t.classList.remove("active");
                });
          },
        });
      return r;
    };
    createWidgets = () => {
      const e = this;
      this.iterateWidgets((t, i) => {
        e.createWidget(i, t);
      });
    };
    removeEvents = (e) => {
      let t = e.cloneNode(!0);
      return e.parentNode.replaceChild(t, e), t;
    };
    getItemsPerSlide = (e) => {
      const t = e.dataset ?? [];
      let i = t.slidesXl ?? 4;
      return (
        window.innerWidth < 597
          ? (i = t.slidesSm ?? 1)
          : window.innerWidth < 970
          ? (i = t.slidesMd ?? 2)
          : window.innerWidth < 1400 && (i = t.slidesLg ?? 3),
        Number(i)
      );
    };
    hideSliderPreview(e) {
      this.iterateWidgets((t, i) => {
        if (!i.shadowRoot) return;
        const s = i.shadowRoot.querySelector(
          ".sa_slider_Widget_review_detail-view"
        );
        s && s !== e && (s.style.display = "none");
      });
    }
    getDateTimeString = (e, t) => {
      const i = this.dateDiffInDays(e, t);
      if (0 === i) return "heute";
      let s = Math.floor(i / 365.25);
      return s > 0
        ? s > 1
          ? "vor " + s + " Jahren"
          : "vor 1 Jahr"
        : ((s = Math.floor(i / 30)),
          s > 0
            ? s > 1
              ? "vor " + s + " Monaten "
              : "vor 1 Monat"
            : i > 1
            ? "vor " + i + " Tagen "
            : "vor 1 Tag");
    };
    dateDiffInDays = (e, t) => {
      const i = Date.UTC(e.getFullYear(), e.getMonth(), e.getDate()),
        s = Date.UTC(t.getFullYear(), t.getMonth(), t.getDate());
      return Math.floor((s - i) / 864e5);
    };
    registerGlobalEvents() {
      if (this.eventRegisterd) return;
      const e = this;
      (this.eventRegisterd = !0),
        window.addEventListener("click", (t) => {
          let i = t.target;
          if (!i.classList.contains("shopauskunft-widget") || !i.shadowRoot)
            return void e.hideSliderPreview();
          if (
            ((i = i.shadowRoot.querySelector(
              ".sa_slider_Widget_review_detail-view"
            )),
            !i || "none" === i.style.display)
          )
            return;
          const s = i.getBoundingClientRect();
          t.clientX < s.x ||
          t.clientX > s.width + s.x ||
          t.clientY < s.y ||
          t.clientY > s.height + s.y
            ? e.hideSliderPreview()
            : e.hideSliderPreview(i);
        });
    }
    handleSlider(e, t, i) {
      const s = this,
        r = this.getItemsPerSlide(t);
      let n = Math.ceil(e.currentSlide / r);
      const l = e.innerElements.length;
      (e.config.perPage = r), (e.perPage = r), s.registerGlobalEvents();
      const o = new Date();
      if (e.selector && e.selector.querySelector("div")) {
        let t = e.selector.querySelector("div").children;
        for (let i = 0; i < t.length; i++) {
          let r = t[i].querySelector("div"),
            n = r.querySelector(".sa_slider_widget_review_time");
          if (n && n.dataset.date) {
            let e = n.dataset.date.split(/[- :]/);
            e[1]--;
            const t = new Date(...e),
              i = s.getDateTimeString(t, o);
            n.innerHTML = i;
          }
          r.addEventListener("click", () => {
            const t = r.getBoundingClientRect(),
              i = e.selector.getBoundingClientRect(),
              s = r
                .closest(".sa-slider-widget_reviews")
                .querySelector(".sa_slider_Widget_review_detail-view");
            (s.innerHTML = r.innerHTML),
              (s.style.position = "absolute"),
              (s.style.top = "50%"),
              (s.style.transform = "translateY(-50%)");
            let n = t.left - i.left - 32;
            n <= -32 && (n = -32),
              (s.style.left = n + "px"),
              (s.style.width = t.width + 64 + "px"),
              (s.style.maxWidth = "100%"),
              (s.style.minHeight = t.height + "px"),
              (s.style.display = "flex");
          });
        }
      }
      e.currentSlide = n * r;
      const a = this.removeEvents(i.shadowRoot.querySelector(".prev")),
        d = this.removeEvents(i.shadowRoot.querySelector(".next")),
        h = i.shadowRoot.querySelector(".sa_slider_widget_reviews_slider");
      if (e.perPage >= l)
        return (
          (h.style.display = "flex"),
          (h.style.justifyContent = "center"),
          (a.style.display = "none"),
          void (d.style.display = "none")
        );
      (h.style.display = "block"),
        (a.style.display = "flex"),
        (d.style.display = "flex");
      const c = i.shadowRoot.querySelector(".sa_slider_widget_reviews_dots"),
        g = Math.ceil(l / e.perPage);
      (c.innerHTML = ""),
        isNaN(g) ||
          [...Array(g).keys()].map((t) => {
            const i = document.createElement("div");
            t === n && i.classList.add("active"),
              i.classList.add("sa_slider_widget_reviews_dot"),
              (i.dataset.index = t.toString());
            let s = t * e.perPage;
            s + e.perPage > l && (s = l - e.perPage),
              (i.onclick = () => e.goTo(s)),
              c.append(i);
          }),
        t.closest(".sa-slider-widget_reviews").append(c),
        a &&
          a.addEventListener("click", () => {
            let t = e.perPage;
            const i = l % e.perPage;
            e.currentSlide + e.perPage === l && 0 !== i && (t = i), e.prev(t);
          }),
        d &&
          d.addEventListener("click", () => {
            let t = e.perPage;
            const i = e.currentSlide + 2 * e.perPage,
              s = i > l && i !== l + e.perPage,
              r = l % e.perPage;
            s && 0 !== r && (t = r), e.next(t);
          });
    }
  }
  document.addEventListener("DOMContentLoaded", () => {
    const e = document.querySelectorAll("div.shopauskunft-widget");
    if (e && e.length > 0) {
      new WidgetHandler(e).render();
    }
  });
})();
